import cx from 'clsx';
import React from 'react';

import * as styles from './ControlWrapper.css';

interface IControlWrapperProps {
  visible?: boolean;
}

export const ControlWrapper: React.FC<React.PropsWithChildren<IControlWrapperProps>> = ({ children, visible }) => {
  return (
    <div className={styles['cont']}>
      <div className={cx(styles['inner'], visible && styles['visible'])}>{children}</div>
    </div>
  );
};
